import { Dispatch } from 'redux';
import { AxiosResponse } from 'axios';
import { DispatchFunction, IProvisioningPolicy, IProvisioningPolicyDTO, IActiveFilter } from '@app/models';
import { GET_ALL_PROVISIONING_POLICIES, GET_PROVISIONING_POLICIES_DTO, PROVISIONING_POLICIES_COUNT } from '@app/store/constants';
import { provisioningPoliciesService } from '@app/services';
import { loadingData } from './basic.actions';

export function handleGetProvisioningPoliciesData(orderBy: string, asc: string, top: number, skip: number,
    isReset: boolean, filters?: IActiveFilter[]): DispatchFunction {
    return ((dispatch: Dispatch) => {
        if (isReset) {
            dispatch(loadingData(true));
            dispatch(provisioningPoliciesCount(0));
            dispatch(getProvisioningPolicies([]));
        }

        provisioningPoliciesService.getProvisioningPolicies(orderBy, asc, top, skip, isReset, filters)
            .then((response: AxiosResponse) => {
                dispatch(getProvisioningPolicies(response.data.value));

                if (isReset) {
                    dispatch(provisioningPoliciesCount(response.data['@odata.count']));
                    dispatch(loadingData(false));
                }
            })
            .catch(() => {
                // TODO: Uncomment when we will set up dev variable
                // console.log(error);
                dispatch(loadingData(false));
            });
    });
}

export function handleGetProvisioningPoliciesDTOData(): DispatchFunction {
    return ((dispatch: Dispatch) => {
        provisioningPoliciesService.getProvisioningPoliciesDTO()
            .then((response: AxiosResponse) => {
                dispatch(getProvisioningPoliciesDTO(response.data.value));
            });
    });
}

export function getProvisioningPolicies(provisioningPolicies: IProvisioningPolicy[]) {
    return {
        payload: provisioningPolicies,
        type: GET_ALL_PROVISIONING_POLICIES
    };
}

export function getProvisioningPoliciesDTO(provisioningPoliciesDTO: IProvisioningPolicyDTO[]) {
    return {
        payload: provisioningPoliciesDTO,
        type: GET_PROVISIONING_POLICIES_DTO
    };
}

export function provisioningPoliciesCount(count: number) {
    return {
        payload: count,
        type: PROVISIONING_POLICIES_COUNT
    };
}